module.exports = __webpack_public_path__ + "img/fallback-companylogo.4bb2fbc3.svg";